import { bl_cms_user_notification_link_RowClass } from '../../dbschema/bl_cms_user_notification_link.model';
import { BaseContainerModel } from '../base-container.model';

export class UserNotificationLinkContainerModel extends BaseContainerModel {
  bl_cms_user_notification_link: bl_cms_user_notification_link_RowClass = new bl_cms_user_notification_link_RowClass();
}
